module.exports = __webpack_public_path__ + "static/media/banner-cofoe.a5ea6258.png";